import { render, staticRenderFns } from "./LogworkTable.vue?vue&type=template&id=16ef3cb7&scoped=true&"
import script from "./LogworkTable.vue?vue&type=script&lang=ts&"
export * from "./LogworkTable.vue?vue&type=script&lang=ts&"
import style0 from "./LogworkTable.vue?vue&type=style&index=0&id=16ef3cb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef3cb7",
  null
  
)

export default component.exports